module.exports = __webpack_public_path__ + "media/bell_ring2.b416d27e.wav";